<template>
  <div>
    <div class="content-list" :class="[showTable?'bgTable':'']">
      <div class="content-top" v-show="!showTable">
<!--        <p class="content-title">预约管理</p>-->
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item" style="width: 28%">
              <label>预约门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item" @change="shopChange">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item" style="width: 28%">
              <label>年月筛选</label>
              <el-date-picker
                  v-model="date"
                  type="date"
                  placeholder="月份"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  style="width: 100%; flex: 1"
                  :clearable="false"
              />

            </div>
            <div class="content-input-item" style="width: 10%">
              <el-button type="primary" v-show="!showTable" @click="backToday" style="margin-left: 8px">回到今天</el-button>
              <el-button type="warning" v-show="!showTable"  @click="addConsume(-1)" style="margin-left: 8px">录入消费</el-button>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn" :style="{flexDirection: showTable?'column':'row'}">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPageFrom()" style="width: 88px;"> 查询 </ElButtons>
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">视图</ElButtons>-->
              <el-button v-if="!openState" @click="openAll(true)">全部展开</el-button>
              <el-button v-else @click="openAll(false)">全部收起</el-button>
              <el-button @click="changeView" :style="{marginTop: showTable?'12px':''}">切换视图</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-scrollbar :height="showTable?scrollTableHeight:scrollHeight"  ref="scrollBar" @scroll="scroll" v-loading="collLoading">
        <div class="shadow" v-if="!showTable"></div>
        <div v-show="!showTable"  class="collapse-main" >
          <el-collapse v-model="activeNames" >
            <div class="collapse-item" v-for="(item, index) of collapseList" :key="item.name" ref="ref">
              <el-collapse-item :name="index + 1">
                <template #title>
                  <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap">
                    <div style="display: flex; flex-wrap: nowrap; align-items: center">
                      <span style="font-weight: bold;white-space: nowrap">{{item.weekDayName}}</span>
                      <span style="margin-left: 24px;font-weight: bold;white-space: nowrap">洗护只数：{{item.washCount}}</span>
                      <span style="margin-left: 24px;font-weight: bold;white-space: nowrap">新客数量：{{item.newUserCount}}</span>
<!--                      <el-button v-if="activeNames.indexOf(index + 1) > -1" style="margin-left: 24px;" type="danger" plain @click.stop="goVisit">需回访（{{needVisitNum}}）</el-button>-->
<!--                      <el-button v-if="activeNames.indexOf(index + 1) > -1 && needRecheckNum > 0" @click.stop="goVisit">需复核<span>（{{needRecheckNum}}）</span></el-button>-->
<!--                      <el-button v-if="activeNames.indexOf(index + 1) > -1 && recheckNoPassNum > 0" @click.stop="goVisit">复核不通过<span>（{{recheckNoPassNum}}）</span></el-button>-->
                      <div class="btn-badge" style="margin-left: 24px;">
                        <el-button v-if="activeNames.indexOf(index + 1) > -1" @click.stop="goVisit">需回访（{{needVisitNum}}）</el-button>
                        <div class="red-dot" v-if="activeNames.indexOf(index + 1) > -1 && needVisitNum > 0"></div>
                      </div>
                      <div class="btn-badge" v-if="activeNames.indexOf(index + 1) > -1 && needRecheckNum > 0">
                        <el-button @click.stop="goVisit">需复核<span>（{{needRecheckNum}}）</span></el-button>
                        <div class="red-dot"></div>
                      </div>
                      <div class="btn-badge" v-if="activeNames.indexOf(index + 1) > -1 && recheckNoPassNum > 0">
                        <el-button @click.stop="goVisit">复核不通过<span>（{{recheckNoPassNum}}）</span></el-button>
                        <div class="red-dot"></div>
                      </div>
                    </div>
                    <div style="margin-right: 24px;display: flex; flex-wrap: nowrap" v-if="activeNames.indexOf(index + 1) > -1">
                      <el-button v-if="appletOpen" type="success" plain @click.stop="getDayProPage(index, item, -1)">待确认（{{item.checkNum}}）</el-button>
                      <el-button type="primary" plain @click.stop="getDayProPage(index, item, 3)">待到店（{{item.preNum}}）</el-button>
                      <el-button type="warning" plain @click.stop="getDayProPage(index, item, 1)">服务中（{{item.serviceNum}}）</el-button>
                      <el-button type="info" plain @click.stop="getDayProPage(index, item, 2)">已离店（{{item.leaveNum}}）</el-button>
                      <el-button plain @click.stop="getDayProPage(index, item)">全部显示（{{item.allNum}}）</el-button>
                    </div>
                  </div>
                </template>
                <div class="item-data">
                  <div class="item-data-left">
                    <table>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>预约1</td>
                        <td>预约2</td>
                        <td>预约3</td>
                        <td>预约4</td>
                      </tr>
                      <tr v-for="(e,idx) of item.preBookInfoHourList" :key="idx">
                        <td class="table-time">
                          <span class="table-time-item">{{e.hourName}}</span>
                          <span class="table-time-item-last" v-if="idx == item.preBookInfoHourList.length -1">{{e.hourEnd}}</span>
                        </td>
                        <td></td>
                        <td v-for="d in 4" :key="d">
                          <div v-if="e.preBookInfoList[d-1]" class="preCard" @click="editProBook(d, e.preBookInfoList[d-1], index, item)"  :class="bgColor[e.preBookInfoList[d-1].state + 1]">
                            <div class="new-tag" v-if="e.preBookInfoList[d-1].firstState > 0">
                              <img v-if="e.preBookInfoList[d-1].firstState == 2" alt="" src="../../assets/image/new-tag.png"/>
                              <img v-if="e.preBookInfoList[d-1].firstState == 1" alt="" src="../../assets/image/new-tag-kua.png"/>
                            </div>
                            <div class="preCard-text" :class="borderColor[e.preBookInfoList[d-1].state + 1]">
                              <div v-if="e.preBookInfoList[d-1].petSelect.length > 0" style="padding: 0" class="preCard-pet">
                                <span v-for="(pet, index) in e.preBookInfoList[d-1].petSelect.slice(0, 2)" :key="index" style="margin-right: 6px;">{{pet.petBreedColorName}}{{pet.woolState == 1?'短毛':pet.woolState == 2?'长毛':''}}（{{pet.name}}）</span>
                                <span v-if="e.preBookInfoList[d-1].petSelect.length > 2">等{{e.preBookInfoList[d-1].petSelect.length}}只</span>

                                <div v-if="e.preBookInfoList[d-1].state > -1 && e.preBookInfoList[d-1].firstState <= 0" style="padding: 6px 0 4px">
                                  <el-button v-if="e.preBookInfoList[d-1].inviteEvaluationState == null" type="primary" size="small" @click.stop="addInvite(e.preBookInfoList[d-1], 1)">邀请好评返现</el-button>
                                  <el-button v-else-if="e.preBookInfoList[d-1].inviteEvaluationState == 2"  type="success" size="small" disabled="">审核通过</el-button>
                                  <el-button v-else-if="e.preBookInfoList[d-1].inviteEvaluationState == 4"  type="success" size="small" disabled="">已过期</el-button>
                                  <el-button v-else type="warning" size="small" @click.stop="addInvite(e.preBookInfoList[d-1], 2)">{{e.preBookInfoList[d-1].inviteEvaluationState == 1?'待审核':e.preBookInfoList[d-1].inviteEvaluationState == 3?'审核不通过':'取消邀请'}}</el-button>
                                </div>

                              </div>

                              <p v-else class="preCard-pet">宠物未添加</p>
                              <p style="display: flex;"><label>时间：</label>
<!--                                <span class="preTime" :class="timeColor[e.preBookInfoList[d-1].state + 1]">-->
                                <span style="margin-right: 8px">
                                  {{e.preBookInfoList[d-1].preDay.substring(5)}}
                                </span>
                                <span>
                                  {{e.preBookInfoList[d-1].preTime}}
                                </span>
                              </p>
                              <p style="display: flex;flex-wrap: wrap">
                                <span style="margin-right: 20px;">
                                  <span>主人：</span>
                                  <span class="userName" :class="timeColor[e.preBookInfoList[d-1].state + 1]" @click.stop="userInfoDialog(e.preBookInfoList[d-1].userInfo.id)">{{e.preBookInfoList[d-1].userInfo.name}}</span>
                                </span>
                                <span style="display: flex;">
                                  <span style="margin-right: 10px;">
                                    充值：<span class="userName" :class="timeColor[e.preBookInfoList[d-1].state + 1]" @click.stop="getPayDeductionList(e.preBookInfoList[d-1].userInfo, -2)">{{e.preBookInfoList[d-1].userInfo.userWallet.balanceSum}}</span>/<span class="userName" :class="timeColor[e.preBookInfoList[d-1].state + 1]" @click.stop="getPayDeductionList(e.preBookInfoList[d-1].userInfo, 1)">{{e.preBookInfoList[d-1].userInfo.userWallet.paySum}}</span>

                                  </span>
                                </span>
                              </p>
                              <p style="display: flex;"><label>消费：</label><span class="userName" :class="timeColor[e.preBookInfoList[d-1].state + 1]" @click.stop="getConsumeList(e.preBookInfoList[d-1].userInfo)">{{e.preBookInfoList[d-1].userInfo.userPerfect.preBookNum}}次</span></p>
                              <p style="display: flex;"><label>手机：</label>{{e.preBookInfoList[d-1].userInfo.phone}}</p>
                              <p style="display: flex;"><label>备注：</label>{{e.preBookInfoList[d-1].remark}}</p>
                              <p style="display: flex;" v-if="e.preBookInfoList[d-1].petSelect.length > 0 && e.preBookInfoList[d-1].petSelect.some(item => item.weight > 0)" ><label>体重：</label>
                                <span style="display: flex; flex-wrap: wrap">
                                  <span v-for="(pet, index) in e.preBookInfoList[d-1].petSelect.filter(item => item.weight > 0)" :key="index" style="white-space: nowrap">{{pet.name}}{{pet.weight}}kg{{index < (e.preBookInfoList[d-1].petSelect.length-1)?'，':''}}</span>
                                </span>
                              </p>
                              <p style="display: flex;"><label>项目：</label>
                                <span v-if="e.preBookInfoList[d-1].projectAll">
                                  <span v-if="e.preBookInfoList[d-1].projectAll.content">{{e.preBookInfoList[d-1].projectAll.content}}</span>
                                  <span v-else style="opacity: 0.4">项目已清除</span>
                                </span>
                                <span v-else>
                                  <span v-if="e.preBookInfoList[d-1].editState == 1" style="opacity: 0.4">未添加</span>
                                  <span v-else :class="timeColor[e.preBookInfoList[d-1].state + 1]" class="addLink" @click.stop="addProject(e.preBookInfoList[d-1],index,item)">待添加</span>
                                </span>
                              </p>
                              <p style="display: flex;"><label>支付：</label>
<!--                                <span v-if="e.preBookInfoList[d-1].paymentDetail">{{e.preBookInfoList[d-1].paymentDetail.content}}</span>-->
                                <span v-if="e.preBookInfoList[d-1].paymentDetail">
                                  <span v-if="e.preBookInfoList[d-1].paymentDetail.content">{{e.preBookInfoList[d-1].paymentDetail.content}}</span>
                                  <span v-else style="opacity: 0.4">支付已清除</span>
                                </span>
                                <span v-else>
                                  <span v-if="e.preBookInfoList[d-1].editState == 1" style="opacity: 0.4">未添加</span>
                                  <span v-else :class="timeColor[e.preBookInfoList[d-1].state + 1]" class="addLink" @click.stop="addPayment(e.preBookInfoList[d-1],index,item)">待添加</span>
                                </span>
                              </p>
                              <p v-if="e.preBookInfoList[d-1].snackState">零食：{{e.preBookInfoList[d-1].snackState == 1?'已赠送':e.preBookInfoList[d-1].snackState == 2?'未赠送':''}}</p>
                              <p v-if="e.preBookInfoList[d-1].evaluation" style="display: flex; align-items: center">
                                <label>评星：</label>
                                <el-rate v-model="e.preBookInfoList[d-1].evaluation.rating" disabled allow-half size="large" disabled-void-color="#cccccc"/>
                              </p>
                              <p v-if="e.preBookInfoList[d-1].evaluation" style="display: flex; align-items: center">
                                <label>评价：</label>{{e.preBookInfoList[d-1].evaluation.content}}
                              </p>
                            </div>
                          </div>
                          <div v-else class="addBtn" @click="addProBook(d, item.dateTime, e.hourName.substring(0, 5), index, item)">+</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div v-if="!item.showStat" @click="showStatTable(index,item)" class="stat-btn">业绩统计</div>
                  <div v-else class="item-data-right">
                    <div class="stat-table">
                      <div style="display: flex; align-items: center; cursor: pointer;" @click="getStatPage(index,item)">
                        <ElIcons name="Refresh" color="#409eff" size="16"/>
                        <span style="margin-left: 6px; color: #409eff">刷新</span>
                      </div>
                      <p @click="item.showStat = false" style="cursor: pointer;">收起</p>
                    </div>
                    <el-table
                        ref="multipleTableRef"
                        :data="item.statList"
                        style="width: 100%; margin-bottom: 24px;"
                        v-loading="item.statLoading"
                        @cell-click="toggleSelectionStat"
                        border
                    >
                      <el-table-column property="" label="业绩统计" width="130">
                        <template #default="scope">
                          {{ scope.row.name }}{{scope.row.showType == 1?' (只)':scope.row.showType == 0?' (元)':scope.row.showType == 2?' (次)':''}}
                        </template>
                      </el-table-column>
                      <el-table-column v-for="(admin, x) of adminList" :key="admin.id" :property="admin.id" :index="x" :label="admin.name" width="80">
                        <template #default="scope">
                          <div v-if="scope.row['value' + x]" style="padding: 0">
                            <p v-if="scope.row.showType == 0 " class="stat-link" >{{scope.row['value' + x].price}}</p>
<!--                            <p v-if="scope.row.showType == 0 && scope.row.serviceType == -1" class="stat-link" >{{scope.row['value' + x].price}}</p>-->
                            <p class="stat-link" v-if="scope.row.showType >= 1">{{scope.row['value' + x].amount}}</p>
                          </div>
                          <span v-else>0</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
        <div v-show="showTable" class="content-table">

          <div class="content-input" style="padding-bottom: 16px; margin-bottom: 16px; border-bottom: 1px solid #ededed;">
            <div  class="content-input-left">
              <div class="content-input-item">
                <label>预约门店</label>
                <el-select v-model="tableShopId" placeholder="Select" class="select-item" @change="shopChange">
                  <el-option v-for="item in tableShopIdArray" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <label style="margin-left: 24px; width: 6em">充值次数</label>
                <el-select v-model="payState" placeholder="Select" class="select-item">
                  <el-option v-for="item in payStateArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="content-input-item">
                <label>评星</label>
                <el-select v-model="evaluationRatingMin" placeholder="Select" class="select-item">
                  <el-option v-for="item in ratingArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span style="margin: 0 4px">-</span>
                <el-select v-model="evaluationRatingMax" placeholder="Select" class="select-item">
                  <el-option v-for="item in ratingArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="content-input-item">
                <label style="width: 5em">总消费次数</label>
                <el-input v-model="consumeNumMin" placeholder="次数最小值">
                  <template #suffix>次</template>
                </el-input>
                <span style="margin: 0 4px">-</span>
                <el-input v-model="consumeNumMax" placeholder="次数最大值">
                  <template #suffix>次</template>
                </el-input>
              </div>


              <div class="content-input-item">
                <label>预约状态</label>
                <el-select v-model="state" placeholder="Select" class="select-item">
                  <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <label style="margin-left: 24px; width: 6em">电话回访状态</label>
                <el-select v-model="visitState" placeholder="Select" class="select-item">
                  <el-option v-for="item in visitStateArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="content-input-item">
                <DatePickerRange title="预约时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
              </div>
              <div class="content-input-item">
                <!--              <label>客户搜索</label>-->
                <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
                <el-checkbox v-model="limitState" style="margin-left: 8px; white-space: nowrap; width: 5em">有限制</el-checkbox>
              </div>
            </div>

            <div class="content-input-right">
              <div class="content-input-btn" :style="{flexDirection: showTable?'column':'row'}">
                <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPageFrom()" style="width: 88px;"> 查询 </ElButtons>
                <el-button @click="changeView" :style="{marginTop: showTable?'12px':''}">切换视图</el-button>
              </div>
            </div>

          </div>

          <div class="content-button">
<!--            <div></div>-->
            <el-button type="warning" @click="exportExcel">导出Excel</el-button>
          </div>

          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              @cell-click="toggleSelection"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="updateTime" label="预约时间" width="120">
              <template #default="scope">
                <p>{{ scope.row.preDay }}</p>
                <p>{{ scope.row.preTime }}</p>
              </template>
            </el-table-column>
            <el-table-column property="preShopName" label="预约门店" width="90"/>
            <el-table-column property="" label="预约状态" width="90">
              <template #default="scope">
                {{scope.row.state == 0?'待到店':scope.row.state == 1?'服务中':scope.row.state == 2?'已离店':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="电话回访状态" width="120">
              <template #default="scope">
                {{scope.row.visitState == 0?'未拨打':scope.row.visitState == 1?'未接通':scope.row.visitState == 2?'已拨打':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="客户信息" width="160">
              <template #default="scope">
                <UserInfo :userId="scope.row.userInfo.id" :row="scope.row.userInfo" showList="name,sex,phone,shopName,uid" @confirm="getPage"/>
                <p v-if="scope.row.userInfo.type == 1">类型：门店散客</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="预约宠物" width="160">
              <template #default="scope">
                <div style="margin: 8px 0; padding:0" v-for="(item, index) of scope.row.petSelect" :key="item.id">
                  <p>{{item.petBreedColorName}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="remark" label="预约备注" width="160"/>
            <el-table-column property="projectAllDesc" label="消费项目" class-name="cursor" width="160">
              <template #default="scope">
                <span v-if="scope.row.projectAll">{{scope.row.projectAll.content}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="支付记录" class-name="cursor" width="160">
              <template #default="scope">
                <span v-if="scope.row.paymentDetail">{{scope.row.paymentDetail.content}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="评价短信" class-name="cursor" width="160">
              <template #default="scope">
                <p v-for="(item, index) in scope.row.evaluationSmsList" :key="index" style="margin: 10px 0">
                  <span>{{item.updateTime}}&nbsp;&nbsp;{{item.type == 1?'预约短信':item.type == 2?'消费短信':''}}：{{item.satisfaction == 1?'不满意':item.satisfaction == 2?'一般':item.satisfaction == 3?'满意':''}}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column property="" label="评星" class-name="cursor" width="68">
              <template #default="scope">
                <span v-if="scope.row.evaluation">{{scope.row.evaluation.rating / 2}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="备注" class-name="cursor" width="220">
              <template #default="scope">
                <UserRemark :userRemarkList="scope.row.userRemarkList" />
              </template>
            </el-table-column>
            <el-table-column property="" label="操作" class-name="cursor" width="80" fixed="right" v-if="positionType <= 2">
              <template #default="scope">
                <el-button type="primary" size="small" @click="editVisitState(scope.row, scope.$index)">回访</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {
  getMonthPreBooksList,
  getPreBook,
  getPreBooksByPhoneOrPetName,
  getMonthPreBooksExcel,
  getStatPageList,
  getDayInfo,
  getVisitStatStateNum,
  exportPreBookExcel, exportShopRepurchaseExcel, getAllShopList, addCashbackInvite
} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import UserInfo from "@/components/User/userInfo"
import ProBookDialog from "@/views/preBook/components/ProBookDialog";
import Drawer from "@/assets/js/drawer";
import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
import DatePickerRange from "@/components/DatePickerRange_1";
import userStatList from "@/views/preBook/components/userStatList";
import userInfoDialog from "@/components/User/userInfoDialog";
import {add, Number_SubAll} from "@/assets/shared/util";
import payListDialog from "@/views/user/components/payListDialog";
import DeductionListDialog from "@/views/user/components/DeductionListDialog";
import PayStatList from "@/views/preBook/components/PayStatList";
import ConsumeListDialog from "@/views/user/components/ConsumeListDialog";
import VisitStateDialog from "@/views/preBook/components/VisitStateDialog";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import PayDeductionListDialog from "@/views/user/components/PayDeductionListDialog";

export default {
  name: "PreBookIndex",
  components: { DatePickerRange, SearchComponents, UserRemark, UserInfo },
  data() {
    return {
      pageDataList: [],
      recordList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      collLoading: false,

      shopIdArray: [
        // {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      appletOpenTime: '',
      appletOpen: false,


      tableShopIdArray: [
        {name: '不限', id: 0}
      ],
      tableShopId: 0,

      //预约状态
      stateArray: [
        {label: '不限', value: -1},
        {label: '待到店', value: 0},
        {label: '服务中', value: 1},
        {label: '已离店', value: 2},
      ],
      state: -1,

      //电话回访状态
      visitStateArray: [
        {label: '不限', value: -1},
        {label: '未拨打', value: 0},
        {label: '未接通', value: 1},
        {label: '已拨打', value: 2},
      ],
      visitState: 0,

      //充值次数
      payStateArray: [
        {label: '不限', value: -1},
        {label: '0次', value: 0},
        {label: '1次', value: 1},
        {label: '2次及以上', value: 2},
      ],
      payState: 0,

      evaluationRatingMin: -1,
      evaluationRatingMax: -1,
      ratingArray: [
        {label: '不限', value: -1},
        {label: '0.5', value: 1},
        {label: '1', value: 2},
        {label: '1.5', value: 3},
        {label: '2', value: 4},
        {label: '2.5', value: 5},
        {label: '3', value: 6},
        {label: '3.5', value: 7},
        {label: '4', value: 8},
        {label: '4.5', value: 9},
        {label: '5', value: 10},
      ],

      ownShopList: [],
      // ownShopList: JSON.parse(sessionStorage.getItem('ownShopList')),
      // visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),

      date: '',
      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      activeNames: [new Date().getDate()],
      collapseList: [],
      collapseListItem: [],


      //刷新组
      colList: ['更新时间', '客户信息', '猫咪信息', '消费项目', '支付记录', '总消费金额', '充值余额', '操作', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 3},
        {label : '宠物昵称', value : 2},
        {label : '预约备注', value : 4},
        {label : '宠物品种', value : 5},
        {label : '主人ID', value : 6},
      ],
      searchType: 1,
      searchValue: '',

      limitState: false,

      bgColor: [ 'bg0', 'bg1', 'bg2', 'bg3', 'bg4'],
      timeColor: ['time0','time1','time2','time3','time4'],
      borderColor: ['border0','border1','border2','border3','border4'],

      showTable: false,

      //营业时间
      wStartTime: '',
      wEndTime: '',

      //提成记录
      adminList: [],

      //展开收起
      openState: true,

      //是否可编辑
      editable: false,

      consumeNumMin: 1,
      consumeNumMax: 1,

      // auditNum: 0,
      needRecheckNum: 0,
      needVisitNum: 0,
      recheckNoPassNum: 0,

      positionType: JSON.parse(sessionStorage.getItem('positionType'))

    }
  },
  computed: {
    scrollHeight() {
      return document.body.clientHeight - 104
    },
    scrollTableHeight() {
      return document.body.clientHeight - 48
    }
  },
  watch: {
    $route() {
      if(this.$route.path == '/preBook/index' && !this.showTable){
        this.collLoading = true
        // let nowDate = new Date()
        // let day = nowDate.getDate()
        let day = Number(this.date.substring(8))
        setTimeout(() => {
          // this.$refs.ref[day - 1].scrollIntoView(true)
          // this.$refs.ref[day - 1].scrollBy(0, -56)
          this.$refs.scrollBar.setScrollTop(this.$refs.ref[day - 1].offsetTop - 12)
        }, 500)
        setTimeout(() => {
          this.collLoading = false
        }, 600)

      }
    },
  },
  methods: {

    goVisit() {
      this.$router.push({
        path: '/visit/index'
      });
    },

    getStatNum() {
      getFormData(getVisitStatStateNum, {id: this.shopId}).then(data => {
        // this.auditNum = data.data.auditNum
        this.needRecheckNum = data.data.needRecheckNum
        this.needVisitNum = data.data.needVisitNum
        this.recheckNoPassNum = data.data.recheckNoPassNum
      })
    },

    backToday() {
      // let nowDate = new Date()
      // let day = nowDate.getDate()
      // setTimeout(() => {
      //   // this.$refs.ref[day - 1].scrollIntoView(true)
      //   // this.$refs.ref[day - 1].scrollBy(0, -56)
      //   this.$refs.scrollBar.setScrollTop(this.$refs.ref[day - 1].offsetTop - 12)
      // }, 500)

      let tDate = new Date()
      let year = tDate.getFullYear()
      let month = tDate.getMonth() + 1
      let day = tDate.getDate()
      this.date = year + '-' + (month < 10?'0'+month:month) + '-' + (day < 10?'0'+day:day)
      this.getProPage(true)

    },

    openAll(val) {
      this.activeNames = []
      this.openState = val
      if(val) {
        this.collapseList.map((item, idx) => {
          this.activeNames.push(idx + 1)
        })
      }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.collLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.tableShopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      param['state'] = this.state;
      param['visitState'] = this.visitState;
      param['payState'] = this.payState;
      param['evaluationRatingMin'] = this.evaluationRatingMin;
      param['evaluationRatingMax'] = this.evaluationRatingMax;
      param['consumeNumMax'] = this.consumeNumMax?this.consumeNumMax:0;
      param['consumeNumMin'] = this.consumeNumMin?this.consumeNumMin:0;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMonthPreBooksExcel, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            item.petSelect = []
            item.showStat = false
            item.preBookPetList.map(e => {
              for(let i=0; i<item.userInfo.petList.length; i++) {
                if(e.petId == item.userInfo.petList[i].id) {
                  item.userInfo.petList[i].weight = e.weight
                  item.petSelect.push(item.userInfo.petList[i])
                }
              }
            })
          })
          this.$refs.scrollBar.setScrollTop(0)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.collLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.collLoading = false;
          })
    },

    getPageFrom() {
      if(!this.showTable) {
        this.getProPage(true)
      }else {
        this.showTable = true
        this.getPage()
      }
    },

    changeView() {
     this.showTable = !this.showTable
      if(!this.showTable) {
        this.getProPage(true)
      }else {
        this.getPage()
      }
    },


    getProPage(scroll) {
      this.collLoading = true
      let param = {};
      param['shopId'] = this.shopId;
      param['monthTime'] = this.date.substring(0,7);
      getFormData(getMonthPreBooksList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          // let result = data['data'];
          this.collapseList = data['data'];
          let activeArr = []
          this.collapseList.map((item,index) => {
            item.statList = []
            item.preNum = 0
            item.serviceNum = 0
            item.leaveNum = 0
            item.checkNum = 0
            item.allNum = 0
            item.preBookInfoHourList.map(e => {
              if(e.preBookInfoList.length > 0) {
                activeArr.push(index + 1)
                e.preBookInfoList.map(p => {
                  p.petSelect = []
                  if(p.preBookPetList.length > 0) {
                    p.preBookPetList.map(i => {
                      for(let k=0; k<p.userInfo.petList.length; k++) {
                        if(i.petId == p.userInfo.petList[k].id) {
                          p.userInfo.petList[k].weight = i.weight
                          p.petSelect.push(p.userInfo.petList[k])
                        }
                      }
                    })
                  }
                  p.userInfo.userWallet.paySum = add([p.userInfo.userWallet.paySumOne, p.userInfo.userWallet.paySumTwo, p.userInfo.userWallet.paySumThree, p.userInfo.userWallet.paySumFour, p.userInfo.userWallet.paySumOneGive, p.userInfo.userWallet.paySumTwoGive, p.userInfo.userWallet.paySumThreeGive, p.userInfo.userWallet.paySumFourGive])
                  p.userInfo.userWallet.balanceSum = add([p.userInfo.userWallet.balanceOne, p.userInfo.userWallet.balanceTwo, p.userInfo.userWallet.balanceThree, p.userInfo.userWallet.balanceFour, p.userInfo.userWallet.balanceOneGive, p.userInfo.userWallet.balanceTwoGive, p.userInfo.userWallet.balanceThreeGive, p.userInfo.userWallet.balanceFourGive])

                  if(p.state == 0) {
                    let date = new Date(p.preDay + ' ' + p.preTime + ':00')
                    let nowD = Date.now()
                    console.log(date.getTime())
                    console.log(nowD)
                    if(nowD > date.getTime()) {
                      p.state = 3
                    }
                  }

                  item.allNum ++

                  if(p.state == 0 || p.state == 3) {
                    item.preNum ++
                  }

                  if(p.state == 1) {
                    item.serviceNum ++
                  }

                  if(p.state == 2) {
                    item.leaveNum ++
                  }

                  if(p.state == -1) {
                    item.checkNum ++
                  }

                  if(p.evaluation) {
                    p.evaluation.rating = p.evaluation.rating / 2
                  }

                })
              }
              e.hourEnd = (Number(e.hourName.substring(0,2))+1) < 10?'0' + (Number(e.hourName.substring(0,2))+1) + ':00' : (Number(e.hourName.substring(0,2))+1) + ':00'
            })
          })
          this.activeNames = [new Date().getDate()]
          this.activeNames = this.activeNames.concat(activeArr)
          // console.log(this.collapseList)
          this.wStartTime = this.collapseList[0].preBookInfoHourList[0].hourName
          this.wEndTime = this.collapseList[0].preBookInfoHourList[this.collapseList[0].preBookInfoHourList.length -1].hourEnd
          // console.log('s:' + this.wStartTime)
          // console.log('e:' + this.wEndTime)
          if(scroll) {
            // let nowDate = new Date()
            // let day = nowDate.getDate()
            // console.log(this.date)
            let day = Number(this.date.substring(8))
            // console.log(day)
            setTimeout(() => {
              // console.log(this.$refs.ref[day - 1].offsetTop)
              // this.$refs.ref[day - 1].scrollIntoView(true)
              // console.log(this.$refs)
              this.$refs.scrollBar.setScrollTop(this.$refs.ref[day - 1].offsetTop - 12)
            }, 500)
          }

          this.getStatNum()

        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.collLoading = false
      })
          .catch((response) => {
            this.collLoading = false
          })
    },

    getDayProPage(idx, row, type) {
      this.collLoading = true
      let param = {};
      param['shopId'] = this.shopId;
      param['preDay'] = row.dateTime;
      getFormData(getDayInfo, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          // let result = data['data'];
          let item = data['data'];
          item.statList = []
          item.preNum = 0
          item.serviceNum = 0
          item.leaveNum = 0
          item.allNum = 0
          item.checkNum = 0
          item.preBookInfoHourList.map(e => {
            if(e.preBookInfoList.length > 0) {
              e.preBookInfoList.map(p => {
                p.petSelect = []
                if(p.preBookPetList.length > 0) {
                  p.preBookPetList.map(i => {
                    for(let k=0; k<p.userInfo.petList.length; k++) {
                      if(i.petId == p.userInfo.petList[k].id) {
                        p.userInfo.petList[k].weight = i.weight
                        p.petSelect.push(p.userInfo.petList[k])
                      }
                    }
                  })
                }
                p.userInfo.userWallet.paySum = add([p.userInfo.userWallet.paySumOne, p.userInfo.userWallet.paySumTwo, p.userInfo.userWallet.paySumThree, p.userInfo.userWallet.paySumFour, p.userInfo.userWallet.paySumOneGive, p.userInfo.userWallet.paySumTwoGive, p.userInfo.userWallet.paySumThreeGive, p.userInfo.userWallet.paySumFourGive])
                p.userInfo.userWallet.balanceSum = add([p.userInfo.userWallet.balanceOne, p.userInfo.userWallet.balanceTwo, p.userInfo.userWallet.balanceThree, p.userInfo.userWallet.balanceFour, p.userInfo.userWallet.balanceOneGive, p.userInfo.userWallet.balanceTwoGive, p.userInfo.userWallet.balanceThreeGive, p.userInfo.userWallet.balanceFourGive])

                if(p.state == 0) {
                  let date = new Date(p.preDay + ' ' + p.preTime + ':00')
                  let nowD = Date.now()
                  // console.log(date.getTime())
                  // console.log(nowD)
                  if(nowD > date.getTime()) {
                    p.state = 3
                  }
                }

                item.allNum ++

                if(p.state == 0 || p.state == 3) {
                  item.preNum ++
                }

                if(p.state == 1) {
                  item.serviceNum ++
                }

                if(p.state == 2) {
                  item.leaveNum ++
                }

                if(p.state == -1) {
                  item.checkNum ++
                }

                if(p.evaluation) {
                  p.evaluation.rating = p.evaluation.rating / 2
                }

              })
            }
            e.hourEnd = (Number(e.hourName.substring(0,2))+1) < 10?'0' + (Number(e.hourName.substring(0,2))+1) + ':00' : (Number(e.hourName.substring(0,2))+1) + ':00'
          })

          if(type) {
            item.preBookInfoHourList.map((item, index) => {
              if(item.preBookInfoList.length > 0) {
                for(let i=0; i<item.preBookInfoList.length; i++) {
                  if(type == 3) {
                    if(item.preBookInfoList[i].state != 0 && item.preBookInfoList[i].state != 3) {
                      item.preBookInfoList.splice(i, 1)
                      i--
                    }
                  }else {
                    if(item.preBookInfoList[i].state != type) {
                      item.preBookInfoList.splice(i, 1)
                      i--
                    }
                  }
                }
              }
            })
          }

          this.collapseList[idx] = item

          this.getStatNum()

        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.collLoading = false
      })
          .catch((response) => {
            this.collLoading = false
          })
    },

    // cardFilter(idx, row, type) {
    //   this.getDayProPage(idx, row)
    //   setTimeout(()=> {
    //
    //
    //     this.collapseList[idx].preBookInfoHourList.map((item, index) => {
    //       if(item.preBookInfoList.length > 0) {
    //         for(let i=0; i<item.preBookInfoList.length; i++) {
    //           if(type == 0) {
    //             if(item.preBookInfoList[i].state != 0 && item.preBookInfoList[i].state != 3) {
    //               item.preBookInfoList.splice(i, 1)
    //               i--
    //             }
    //           }else {
    //             if(item.preBookInfoList[i].state != type) {
    //               item.preBookInfoList.splice(i, 1)
    //               i--
    //             }
    //           }
    //         }
    //       }
    //     })
    //
    //   }, 500)
    //
    //
    // },

    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },



    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '用户备注',
          component: UserRemarkDialog,
          data: {
            id: row.userInfo.id,
            width: '1100px'
          },
          close: () => {
            // row['userInfo']['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
            this.getPage()
          }
        })
      }

      if(column.label == '消费项目') {
        this.addProject(row)
      }

      if(column.label == '支付记录') {
        this.addPayment(row)
      }

    },

      toggleSelectionStat(row, column, cell, event) {

      // console.log(row)
      // console.log(column)
      // console.log(cell)
      // console.log(event)
      //店员提成记录
      if( row['value' + column.index] && row.serviceType != -1 ) {
        Dialog.open({
          title: '【' + column.label + '】的业绩记录',
          component: userStatList,
          data: {
            shopId: this.shopId,
            adminId: column.property,
            statTime: row.dateTime,
            serviceType: row.serviceType,
            width: '1000px'
          }
        })
      }

      if( row['value' + column.index] && row.serviceType == -1 ) {
        Dialog.open({
          title: '【' + column.label + '】的充值记录',
          component: PayStatList,
          data: {
            shopId: this.shopId,
            adminId: column.property,
            statTime: row.dateTime,
            serviceType: row.serviceType,
            width: '1000px'
          }
        })
      }


    },


    addProject(item, index, row) {
      if(!this.editable) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前角色没有该门店的编辑权限',
          type: 'warning'
        });
        return false
      }
      if(item.state == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前预约单未确认，无法操作',
          type: 'warning'
        });
        return false
      }
      getFormData(getPreBook, {id: item.id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let bookForm = data.data
          let proDetailForm = {};
          let idx = -1
          let _title = ''
          if(!bookForm.projectAll) {
            _title = '添加消费项目';
          }else {
            _title = '编辑消费项目';
            proDetailForm = bookForm.projectAll
            idx = 1
          }

          Drawer.open({
            title: _title,
            component: EditProjectDialog,
            data: {
              userForm: bookForm.userInfo,
              preBookId: bookForm.id,
              idx: idx,
              proDetailForm: proDetailForm,
              // checkList: bookForm.petIdList,
              preBookPetList: bookForm.preBookPetList,
              petList: bookForm.userInfo.petList,
              shopId: bookForm.preShopId,
              shopName: bookForm.preShopName,
              width: 1200
            },
            confirm: (result) => {
              if(!this.showTable) {
                this.getDayProPage(index, row)
              }else {
                this.getPage()
              }
            }
          })

        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    addPayment(item, index, row) {
      if(!this.editable) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前角色没有该门店的编辑权限',
          type: 'warning'
        });
        return false
      }
      if(item.state == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前预约单未确认，无法操作',
          type: 'warning'
        });
        return false
      }
      getFormData(getPreBook, {id: item.id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let bookForm = data.data
          let payDetailForm = {};
          let idx = -1
          let _title = ''
          if(!bookForm.paymentDetail) {
            _title = '添加支付记录'
          }else {
            _title = '编辑支付记录'
            payDetailForm = bookForm.paymentDetail
            idx = 1
          }
          Drawer.open({
            title: _title,
            component: EditPaymentDialog,
            data: {
              userForm: bookForm.userInfo,
              // userId: this.userInfo.id,
              preBookId: bookForm.id,
              idx: idx,
              payDetailForm: payDetailForm,
              // checkList: bookForm.petIdList,
              preBookPetList: bookForm.preBookPetList,
              petList: bookForm.userInfo.petList,
              shopId: bookForm.preShopId,
              shopName: bookForm.preShopName,
              width: 1000,
              proContent: bookForm.projectAll?bookForm.projectAll.content:'',
              totalMoney: bookForm.projectAll?bookForm.projectAll.totalMoney:0
            },
            confirm: (result) => {
              if(!this.showTable) {
                this.getDayProPage(index, row)
              }else {
                this.getPage()
              }
            }
          })

        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    addProBook(idx, dateTime, preTime, index, row) {
      if(!this.editable) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前角色没有该门店的编辑权限',
          type: 'warning'
        });
        return false
      }
      let _title = '创建预约单';
      let bookForm = {}
      let timeArr = preTime.split(':')
      switch (idx) {
        case 1:
          bookForm.preTime = timeArr[0] + ':00';
          break;
        case 2:
          bookForm.preTime = timeArr[0] + ':15';
          break;
        case 3:
          bookForm.preTime = timeArr[0] + ':30';
          break;
        case 4:
          bookForm.preTime = timeArr[0] + ':45';
          break;
      }
      Dialog.open({
        title: _title,
        component: ProBookDialog,
        data: {
          bookForm: bookForm,
          dateTime: dateTime,
          shopId: this.shopId,
          startTime: this.wStartTime,
          endTime: this.wEndTime,
          editable: this.editable,
          appletOpen: this.appletOpen,
          ids: -1,
          width: '800px',
        },
        confirm: (result) => {
          // this.getProPage()
          this.getDayProPage(index, row)
        }
      })
    },

    editProBook(idx, item, index, row) {
      console.log('editable:' + this.editable)
      getFormData(getPreBook, {id: item.id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let _title = '预约详情';
          let bookForm = data.data
          bookForm.userInfo.userWallet.paySum = add([bookForm.userInfo.userWallet.paySumOne, bookForm.userInfo.userWallet.paySumTwo, bookForm.userInfo.userWallet.paySumThree, bookForm.userInfo.userWallet.paySumFour, bookForm.userInfo.userWallet.paySumOneGive, bookForm.userInfo.userWallet.paySumTwoGive, bookForm.userInfo.userWallet.paySumThreeGive, bookForm.userInfo.userWallet.paySumFourGive])
          // bookForm.userInfo.userWallet.balanceSum = add([bookForm.userInfo.userWallet.balanceOne, bookForm.userInfo.userWallet.balanceTwo, bookForm.userInfo.userWallet.balanceThree, bookForm.userInfo.userWallet.balanceFour, bookForm.userInfo.userWallet.balanceOneGive, bookForm.userInfo.userWallet.balanceTwoGive, bookForm.userInfo.userWallet.balanceThreeGive, bookForm.userInfo.userWallet.balanceFourGive])
          bookForm.userInfo.userWallet.balanceSum = add([bookForm.userInfo.userWallet.balanceOne, bookForm.userInfo.userWallet.balanceTwo, bookForm.userInfo.userWallet.balanceThree, bookForm.userInfo.userWallet.balanceFour])
          bookForm.userInfo.userWallet.balanceSumGive = add([bookForm.userInfo.userWallet.balanceOneGive, bookForm.userInfo.userWallet.balanceTwoGive, bookForm.userInfo.userWallet.balanceThreeGive, bookForm.userInfo.userWallet.balanceFourGive])
          bookForm.userInfo.userWallet.balanceSumAll = add([bookForm.userInfo.userWallet.balanceSum, bookForm.userInfo.userWallet.balanceSumGive])
          bookForm.userInfo.userWallet.balanceSumOne = add([bookForm.userInfo.userWallet.balanceOne, bookForm.userInfo.userWallet.balanceOneGive])
          bookForm.userInfo.userWallet.balanceSumTwo = add([bookForm.userInfo.userWallet.balanceTwo, bookForm.userInfo.userWallet.balanceTwoGive])
          bookForm.userInfo.userWallet.balanceSumThree = add([bookForm.userInfo.userWallet.balanceThree, bookForm.userInfo.userWallet.balanceThreeGive])
          bookForm.userInfo.userWallet.balanceSumFour = add([bookForm.userInfo.userWallet.balanceFour, bookForm.userInfo.userWallet.balanceFourGive])
          Dialog.open({
            title: _title,
            component: ProBookDialog,
            data: {
              bookForm: bookForm,
              shopId: this.shopId,
              startTime: this.wStartTime,
              endTime: this.wEndTime,
              editable: this.editable,
              appletOpen: this.appletOpen,
              ids: idx,
              width: '800px',
            },
            confirm: (result) => {
              // this.getProPage()
              this.getDayProPage(index, row)
            }
          })
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    showStatTable(idx, item) {
      this.getStatPage(idx,item)
      item.showStat = true
    },

    getStatPage(idx,item) {
      item.statLoading = true
      let param = {}
      param['shopId'] = this.shopId
      param['statTime'] = item.dateTime
      // param['shopId'] = 2
      // param['statTime'] = '2023-08-17'
      getFormData(getStatPageList, param).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let dataList = data.data
          this.adminList = dataList.adminList
          // this.collapseList[idx].statList = data.data
          let projectList = dataList.projectServiceTypeList
          let projectStatList = dataList.projectServiceStatList
          this.collapseList[idx].statList = []
          for(let i=0; i<projectList.length; i++) {
            let obj = {}
            obj.name = projectList[i].name
            obj.showType = projectList[i].showType
            obj.serviceType = projectList[i].serviceType
            obj.dateTime = item.dateTime
            for(let j=0; j<this.adminList.length; j++) {
              for (let k=0; k<projectStatList.length; k++) {
                if(projectStatList[k].serviceType == projectList[i].serviceType && projectStatList[k].adminId == this.adminList[j].id) {
                  obj['value' + j] = projectStatList[k]
                }
              }
            }
            this.collapseList[idx].statList.push(obj)
          }
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        item.statLoading = false
      }).catch(()=> {
        item.statLoading = false
      })
    },

    shopChange() {
      if(!this.showTable) {
        this.getProPage(true)
      }else {
        this.getPage()
      }
      // if(this.visibleShopList.every(item => item.id != this.shopId)) {
      //   this.editable = false
      // }else {
      //   this.editable = true
      // }
      this.editable = false
      this.ownShopList.map(item => {
        if(item.id == this.shopId) {
          this.appletOpenTime = item.appletOpenTime
          this.appletOpen = this.appletOpenTime && new Date(this.appletOpenTime) < (new Date())?true:false
          if(item.isEdit == 1) {
            this.editable = true
          }
        }
      })
      console.log(this.appletOpenTime)
    },

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        close: (result) => {
          this.getProPage()
        }
      })
    },


    // getPayList(row) {
    //   Dialog.open({
    //     title: '充值记录',
    //     component: payListDialog,
    //     data: {
    //       id: row.id,
    //       userForm: row,
    //       width: '1100px'
    //     },
    //     close: () => {
    //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
    //         this.getProPage()
    //       }
    //       sessionStorage.removeItem('recordState')
    //     }
    //   })
    // },
    //
    // getDeductionList(row) {
    //   Dialog.open({
    //     title: '抵扣记录',
    //     component: DeductionListDialog,
    //     data: {
    //       id: row.id,
    //       userForm: row,
    //       width: '1100px'
    //     },
    //     close: () => {
    //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
    //         this.getProPage()
    //       }
    //       sessionStorage.removeItem('recordState')
    //     }
    //   })
    // },

    getPayDeductionList(row, type) {
      Dialog.open({
        title: '充值抵扣记录',
        component: PayDeductionListDialog,
        data: {
          id: row.id,
          userForm: row,
          width: '1100px',
          type: type
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getProPage()
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    getConsumeList(row) {
      let userForm = Object.assign({}, row);
      Dialog.open({
        title: '消费单',
        component: ConsumeListDialog,
        data: {
          id: row.id,
          width: '1100px',
          userForm: userForm,
          // shopIdArray: this.shopIdArray,
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getProPage()
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    exportExcel() {
      let url = HOST + exportPreBookExcel
          + '?pageNum=' + this.currentPage
          + '&shopId=' + this.tableShopId
          + '&startTime=' + (this.startTime?this.startTime:'')
          + '&endTime=' + (this.endTime?this.endTime:'')
          + '&searchValue=' + (this.searchValue?this.searchValue:'')
          + '&searchType=' + this.searchType
          + '&state=' + this.state
          + '&visitState=' + this.visitState
          + '&payState=' + this.payState
          + '&evaluationRatingMin=' + this.evaluationRatingMin
          + '&evaluationRatingMax=' + this.evaluationRatingMax
          + '&consumeNumMax=' + (this.consumeNumMax?this.consumeNumMax:0)
          + '&consumeNumMin=' + (this.consumeNumMin?this.consumeNumMin:0)
          + '&limitState=' + (this.limitState?1:0)
      window.location.href = url;
    },

    editVisitState(row, idx) {
      let visitForm = Object.assign({}, row);
      Dialog.open({
        title: '电话回访',
        component: VisitStateDialog,
        data: {
          visitForm: visitForm,
          ids: idx,
          width: '500px',
        },
        confirm: (res) => {
          this.getPage()
          // row.visitState = res.visitState
          // row.visitRemark = res.visitRemark
        }
      })
    },

    getShopList() {
      getFormData(getAllShopList).then(data=> {
        let allShop = data.data
        this.ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
        this.ownShopList.map(item => {
          for(let i=0; i<allShop.length; i++) {
            if(item.id == allShop[i].id) {
              item.appletOpenTime = allShop[i].appletOpenTime
            }
          }
        })
        this.shopIdArray = this.shopIdArray.concat(this.ownShopList)
        this.tableShopIdArray = this.tableShopIdArray.concat(this.ownShopList)
        this.shopId = this.shopIdArray[0].id
        this.appletOpenTime = this.shopIdArray[0].appletOpenTime
        this.appletOpen = this.appletOpenTime && new Date(this.appletOpenTime) < (new Date())?true:false
        this.ownShopList.map(item => {
          if(item.id == this.shopId && item.isEdit == 1) {
            this.editable = true
          }
        })
        this.getProPage(true);
      })
    },

    addConsume(idx, row) {
      let consumeForm = {}
      let consumeId = 0
      // if(idx > -1) {
      //   consumeForm = Object.assign({}, row);
      //   consumeId = consumeForm.id
      // }
      Dialog.open({
        title: '消费单',
        component: ConsumeDetailDialog,
        data: {
          userForm: {},
          consumeId: consumeId,
          shopId: this.shopId,
          showAddBtn: true,
          idx: idx,
          width: '800px'
        },
        confirm: (result) => {
          // this.getPage();
          // this.getUserInfo()
          // sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    addInvite(proBook, type) {
      this.$confirm('确定' + (type == 1?'邀请':'取消') + '主人【' + proBook.userInfo.name + '】进行邀请好评返现吗？').then(() => {
        let param = {}
        param['id'] = proBook.id
        param['type'] = type
        postFormData(addCashbackInvite, param).then(data => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            proBook.inviteEvaluationState = type == 1?-1:null
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })

    let tDate = new Date()
    let year = tDate.getFullYear()
    let month = tDate.getMonth() + 1
    let day = tDate.getDate()
    this.date = year + '-' + (month < 10?'0'+month:month) + '-' + (day < 10?'0'+day:day)


    // if(this.visibleShopList.every(item => item.id != this.shopId)) {
    //   this.editable = false
    // }
    this.getShopList()



  },

}
</script>

<style scoped>
.content-list {
  position: relative;
  background-color: #f6f6f6;
  /*padding-bottom: 16px;*/
  min-height: 90vh;
}
.list-input-item {
  margin-right: 20px;
}
.content-top {
  background-color: #ffffff;
  /*margin-bottom: 12px;*/
  padding: 0 24px 12px;
  /*height: 56px;*/
  /*position: sticky;*/
  /*top: 0;*/
  /*left: 0;*/
  /*z-index: 99;*/
  /*box-shadow: 0 0 12px rgba(0,0,0,0.1);*/
  /*border-bottom: 1px solid #ededed;*/
}
.collapse-main {
  margin: 12px 16px 0;
}
.collapse-item{
  margin-bottom: 12px;
  padding: 0 24px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}
.item-data {
  display: flex;
  justify-content: space-between;
}
.item-data-left {
  border: 2px solid #ebeef5;
  /*border-width: 2px 1px 1px 2px;*/
  border-radius: 8px;
  width: 100%;
  /*overflow: hidden;*/
  height: 100%;
}
.item-data-right {
  /*width:340px;*/
  height: 100%;
  margin-left: 16px;
  border: 2px solid #ebeef5;
  border-radius: 8px;
  padding: 0 24px 0;
  white-space: nowrap;
}

.stat-btn {
  padding: 0 6px;
  margin: 49px 0 0 -2px;
  cursor: pointer;
  writing-mode: vertical-lr;
  letter-spacing: 3px;
  background-color: #409eff;
  border-radius: 0 6px 6px 0;
  height: 90px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}

.stat-btn:hover {
  background-color: #58aaff;
}

.stat-table {
  min-width: 200px;
  padding: 11px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

table {
  width: 100%;
  /*border: 2px solid #ebeef5;*/
  /*border-width: 2px 0 0 2px;*/
  border-radius: 8px;
  border-collapse: collapse;
  table-layout:fixed;
  height: 100%;
}
tr {
  min-height: 64px;
  /*border: 1px solid #ebeef5;*/
}
tr td:last-child {
  border-right: none;
}

tr td:first-child {
  border: none;
  width: 4em;
}

.table-time {
  position: relative;
  color: #606266;
}

.table-time-item {
  position: absolute;
  background-color: #ffffff;
  padding: 0 8px;
  top: -12px;
  left: 20px;
}

.table-time-item-last {
  position: absolute;
  background-color: #ffffff;
  padding: 0 8px;
  bottom: -11px;
  left: 20px;
  /*color: #ccc;*/
  z-index: 9;
}

tr td:nth-child(2) {
  width: 1%;
}

table tr:last-child td{
  border-bottom: none;
}

table tr:first-child {
  text-align: center;
  color: #606266;
}

table tr:first-child td{
  padding: 12px;
}

td {
  border: 1px solid #ebeef5;
  border-width: 0 1px 1px 0;
  width: 23%;
  /*padding: 12px;*/
}
th {
  border: 1px solid #ebeef5;
  border-width: 0 1px 1px 0;
  /*padding: 12px;*/
}

td div {
  padding: 12px;
}

.addBtn {
  font-size: 18px;
  background-color: #fafafa;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.addBtn:hover {
  opacity: 1;
}

.preCard {
  padding: 0;
  margin: 12px;
  font-size: 13px;
  /*border-left: 4px solid #409eff;*/
  /*background-color: rgba(64, 158, 255, 0.05);*/
  border-radius: 8px;
  overflow: hidden;
  /*display: flex;*/
  cursor: pointer;
  position: relative;
}

.preTime {
  color: #409eff;
}

.preCard p {
  width: 100%;
  display:inline-block;
  /*word-break:keep-all;*/
  /*white-space: nowrap;*/
  /*overflow: hidden;*/
  /*text-overflow:ellipsis;*/
  line-height: 1.5;
}

.preCard-line {
  width: 4px;
  padding: 0;
  background-color: #409eff;
}
.preCard-text {
  flex: 1;
  padding: 16px 24px 16px 20px;
  line-height: 1.5;
  border-left: 4px solid #409eff;
}

.preCard-pet {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}

.new-tag {
  /*width: 48px;*/
  /*height: 48px;*/
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}

.new-tag img {
  width: 48px;
  height: 48px;
}

.bg0 {
  background-color: #f5faf5;
}

.time0 {
  color: #42b983;
}

.border0 {
  border-color: #42b983;
}

.bg1 {
  background-color: #F5FAFF;
}

.time1 {
  color: #409EFF;
}

.border1 {
  border-color: #409EFF;
}

.bg2 {
  background-color: #FDFAF5;
}

.time2 {
  color: #DA8C18;
}

.border2 {
  border-color: #DA8C18;
}

.bg3 {
  background-color: #f8f8f8;
}

.time3 {
  color: #409EFF;
}

.border3 {
  border-color: #999999;
}

.bg4 {
  background-color: #fef9f9;
}

.time4 {
  color: #F56C6C;
}

.border4 {
  border-color: #F56C6C;
}

.bgTable {
  background-color: #ffffff;
}

.content-table {
  padding: 12px 24px 24px;
  background-color: #ffffff;
}

.userName {
  /*color: #409eff;*/
  cursor: pointer;
}

.userName:hover {
  text-decoration-line: underline;
}

.addLink:hover {
  text-decoration-line: underline;
}

.shadow {
  position: absolute;
  /*box-shadow: 0 0 12px rgba(0,0,0,0.1);*/
  background: linear-gradient(to bottom, rgba(0,0,0,0.06), rgba(0,0,0,0));
  width: 100%;
  top: 0;
  height: 8px;
  z-index: 999;
}

.stat-link {
  color: #409eff;
  cursor: pointer;
}

.stat-link:hover {
  text-decoration-line: underline;
}

.btn-badge {
  position: relative;
  margin-left: 12px;
  margin-bottom: 2px;
}

.red-dot {
  position: absolute;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: #f56c6c;
  top: 11px;
  right: -3px;
}

</style>
